import React from 'react'
import styles from './index.module.css'
import { timeStringFromSecondsSinceEpoch } from '../../../utils/time_helpers'
import { IconCheck } from '@tabler/icons-react'

const ValidLineItem = (props) => {

    const {
        qr_data,
        device_name,
        created_at,
        event_name,
        product_variant_title
    } = props.scan

    return (
        <>
            <div className={styles.line}>

                <div className={styles.header}>
                    <div className={styles.eventName}>{event_name}</div>
                    {product_variant_title &&
                        <div className={styles.variantTitle}>{product_variant_title}</div>
                    }
                </div>

                <div className={styles.body}>
                    <IconCheck size={14} className={styles.sucessIcon}/>

                    <div className={styles.code}>
                        {qr_data}
                    </div>

                    <div className={styles.deviceName}>
                        {device_name}
                    </div>

                    <div className={styles.time}>
                        {timeStringFromSecondsSinceEpoch(created_at)}
                    </div>
                </div>

            </div>
        </>
    )

}

export default ValidLineItem
